<template>
  <header class="ds-navbar ds-scope" :data-testid="TEST_ID.NAVBAR.ROOT">
    <div class="ds-navbar__inner">
      <div v-if="isMobileView" class="ds-navbar__mobile-top">
        <button class="ds-navbar__hamburger" :data-testid="TEST_ID.NAVBAR.BUTTON_MOBILE_MENU" type="button" @click.stop="toggleMobileMenu" aria-label="Menu">
          <el-icon v-if="mobileMenuOpen"><Close /></el-icon>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <mask id="mask0_472_373" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_472_373)">
              <path d="M4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H4ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H4ZM4 13C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H4Z" fill="#52525B"/>
            </g>
          </svg>
        </button>

        <router-link class="ds-navbar__logo-link" :to="{ name: 'Home' }">
          <img class="ds-navbar__logo" src="@/images/logo.png" alt="Colven" />
        </router-link>

        <div class="ds-navbar__mobile-top-actions">
          <div class="ds-navbar__locale" role="button" tabindex="0" aria-label="Idioma" @click="toggleLocale" @keydown.enter.prevent="toggleLocale" @keydown.space.prevent="toggleLocale">
            <button
              type="button"
              class="ds-navbar__locale-btn ds-body-big-bold"
              :class="{ 'is-active': currentLocale === 'es' }"
            >
              ES
            </button>
            <button
              type="button"
              class="ds-navbar__locale-btn ds-body-big-bold"
              :class="{ 'is-active': currentLocale === 'en' }"
            >
              EN
            </button>
          </div>

          <div class="ds-navbar-dropdown ds-navbar-dropdown--user">
            <button :data-testid="TEST_ID.NAVBAR.BUTTON_USER_MENU" class="ds-navbar__user-btn ds-navbar__user-btn--icon ds-body-big-bold" type="button" @click.stop="toggleUserMenu">
              <svg
                class="ds-navbar__user-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                aria-hidden="true"
              >
                <path d="M9 9C10.6575 9 12 7.6575 12 6C12 4.3425 10.6575 3 9 3C7.3425 3 6 4.3425 6 6C6 7.6575 7.3425 9 9 9ZM9 10.5C6.9975 10.5 3 11.505 3 13.5V14.25C3 14.6625 3.3375 15 3.75 15H14.25C14.6625 15 15 14.6625 15 14.25V13.5C15 11.505 11.0025 10.5 9 10.5Z" fill="currentColor"/>
              </svg>
                <DsArrowUp v-if="isMenuOpen('user')" class="ds-navbar__arrow" />
                <DsArrowDown v-else class="ds-navbar__arrow" />
            </button>
            <div v-if="openMenu === 'user'" :data-testid="TEST_ID.NAVBAR.MENU_USER" class="ds-navbar-dropdown__menu ds-navbar-dropdown__menu--right" role="menu">
              <button v-if="canMenuPerfil" :data-testid="TEST_ID.NAVBAR.ITEM_PROFILE" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('perfil')">{{ $t('PERFIL_perfil') }}</button>
              <button v-if="sid == null" :data-testid="TEST_ID.NAVBAR.ITEM_CHANGE_PASSWORD" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('changePassword')">{{ $t('CHANGE_PASS_changePassword') }}</button>
              <button v-if="canMenu2FA" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('2fa')">{{ $t('TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication') }}</button>
              <button v-if="canMenuContacto" :data-testid="TEST_ID.NAVBAR.ITEM_CONTACT" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('contacto')">{{ $t('NAVBAR_contacto') }}</button>
              <button :data-testid="TEST_ID.NAVBAR.ITEM_LOGOUT" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('logout')">{{ $t('GENERAL_salir') }}</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isMobileView" class="ds-navbar__left">
        <router-link class="ds-navbar__logo-link" :to="{ name: 'Home' }">
          <img class="ds-navbar__logo" src="@/images/logo.png" alt="Colven" />
        </router-link>

        <nav class="ds-navbar__menu" aria-label="Main">
          <button :data-testid="TEST_ID.NAVBAR.LINK_HOME_DESKTOP" :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isHomeActive }]" type="button" @click="$router.push({ name: 'Home' })">
            {{ $t('NAVBAR_inicio') }}
          </button>

          <div v-if="showPedidosMenu" class="ds-navbar-dropdown">
            <button :data-testid="TEST_ID.NAVBAR.BUTTON_PEDIDOS_TOGGLE_DESKTOP" :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isPedidosActive }]" type="button" @click.stop="toggleMenu('pedidos')">
              {{ $t('NAVBAR_pedidos') }}
              <DsArrowUp v-if="isMenuOpen('pedidos')" class="ds-navbar__arrow" />
              <DsArrowDown v-else class="ds-navbar__arrow" />
            </button>
            <div v-if="openMenu === 'pedidos'" :data-testid="TEST_ID.NAVBAR.MENU_PEDIDOS_DESKTOP" class="ds-navbar-dropdown__menu" role="menu">
              <button v-if="canMenuPedido" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/pedidos') }]" type="button" @click="selectMenuCommand('/pedidos')">{{ $t('NAVBAR_pedidos') }}</button>
              <button v-if="canMenuPedidoDistribuidores" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/pedidosDistribuidores') }]" type="button" @click="selectMenuCommand('/pedidosDistribuidores')">{{ $t('NAVBAR_pedidosDistribuidores') }}</button>
              <button v-if="canMenuPedidoSubagentes" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/pedidosSubagentes') }]" type="button" @click="selectMenuCommand('/pedidosSubagentes')">{{ $t('NAVBAR_pedidosSubagentes') }}</button>
              <button v-if="canMenuFirmarRemito" :data-testid="TEST_ID.NAVBAR.ITEM_FIRMAR_REMITOS_DESKTOP" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/firmarRemitos') }]" type="button" @click="selectMenuCommand('/firmarRemitos')">{{ $t('NAVBAR_firmarRemitos') }}</button>
            </div>
          </div>

          <button v-if="canMenuPresupuesto" :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isPresupuestosActive }]" type="button" @click="selectMenuCommand('/presupuestos')">
            {{ $t('NAVBAR_presupuestos') }}
          </button>

          <div v-if="showProductosMenu" class="ds-navbar-dropdown">
            <button :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isProductosActive }]" type="button" @click.stop="toggleMenu('productos')">
              {{ $t('NAVBAR_productos') }}
              <DsArrowUp v-if="isMenuOpen('productos')" class="ds-navbar__arrow" />
              <DsArrowDown v-else class="ds-navbar__arrow" />
            </button>
            <div v-if="openMenu === 'productos'" class="ds-navbar-dropdown__menu" role="menu">
              <button v-if="canMenuRegistroInstalacion" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/garantias') }]" type="button" @click="selectMenuCommand('/garantias')">{{ $t('NAVBAR_reg_instalacion') }}</button>
              <button v-if="canMenuGarantiaProximaVencer" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/garantias/expiracion') }]" type="button" @click="selectMenuCommand('/garantias/expiracion')">{{ $t('NAVBAR_expire_warranty') }}</button>
              <button v-if="canMenuSolicitudServicio" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/solicitudes') }]" type="button" @click="selectMenuCommand('/solicitudes')">{{ $t('NAVBAR_solicitudes') }}</button>
              <button v-if="canMenuAsociarRemito" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/remitos') }]" type="button" @click="selectMenuCommand('/remitos')">{{ $t('NAVBAR_remitos') }}</button>
            </div>
          </div>

          <div v-if="showCuentasMenu" class="ds-navbar-dropdown">
            <button :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isCuentasActive }]" type="button" @click.stop="toggleMenu('cuentas')">
              {{ $t('NAVBAR_cuentas') }}
              <DsArrowUp v-if="isMenuOpen('cuentas')" class="ds-navbar__arrow" />
              <DsArrowDown v-else class="ds-navbar__arrow" />
            </button>
            <div v-if="openMenu === 'cuentas'" class="ds-navbar-dropdown__menu" role="menu">
              <button v-if="canMenuPendientes" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/pendientes') }]" type="button" @click="selectMenuCommand('/pendientes')">{{ $t('NAVBAR_pendientes') }}</button>
              <button v-if="canMenuResumenDeCuenta" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/resumenDeCuenta') }]" type="button" @click="selectMenuCommand('/resumenDeCuenta')">{{ $t('NAVBAR_resumenDeCuenta') }}</button>
            </div>
          </div>

          <div v-if="showComunidadMenu" class="ds-navbar-dropdown">
            <button :class="['ds-navbar__link', 'ds-body-big-bold', { 'is-active': isComunidadActive }]" type="button" @click.stop="toggleMenu('comunidad')">
              {{ $t('NAVBAR_comunidad') }}
              <DsArrowUp v-if="isMenuOpen('comunidad')" class="ds-navbar__arrow" />
              <DsArrowDown v-else class="ds-navbar__arrow" />
            </button>
            <div v-if="openMenu === 'comunidad'" class="ds-navbar-dropdown__menu" role="menu">
              <button v-if="canMenuForo" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/foro') }]" type="button" @click="selectMenuCommand('/foro')">{{ $t('NAVBAR_foro') }}</button>
              <button v-if="canMenuGestionNoticias" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/gestionNoticias') || isRouteActive('/noticia') }]" type="button" @click="selectMenuCommand('/gestionNoticias')">{{ $t('NAVBAR_gestionNoticias') }}</button>
              <button v-if="canMenuGestionArchivo" :class="['ds-navbar-dropdown__item', 'ds-body-medium', { 'is-active': isRouteActive('/archivos') }]" type="button" @click="selectMenuCommand('/archivos')">{{ $t('NAVBAR_archivos') }}</button>
            </div>
          </div>
        </nav>
      </div>

      <div v-if="!isMobileView" class="ds-navbar__right">
        <!--
        <button class="ds-navbar__icon-btn" type="button" aria-label="Notificaciones">
          <svg
            class="ds-navbar__bell-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <mask id="ds-bell-mask" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#ds-bell-mask)">
              <path d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22Z" fill="currentColor"/>
            </g>
          </svg>

          <span v-if="hasNotifications" class="ds-navbar__notification-badge" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <circle cx="7" cy="7" r="7" fill="#01A5E5"/>
            </svg>
            <span class="ds-navbar__notification-count ds-body-xsmall-bold">{{ notificationCount }}</span>
          </span>
        </button>
        -->

        <div class="ds-navbar__locale" role="button" tabindex="0" aria-label="Idioma" @click="toggleLocale" @keydown.enter.prevent="toggleLocale" @keydown.space.prevent="toggleLocale">
          <button
            type="button"
            class="ds-navbar__locale-btn ds-body-big-bold"
            :class="{ 'is-active': currentLocale === 'es' }"
          >
            ES
          </button>
          <button
            type="button"
            class="ds-navbar__locale-btn ds-body-big-bold"
            :class="{ 'is-active': currentLocale === 'en' }"
          >
            EN
          </button>
        </div>

        <div class="ds-navbar-dropdown ds-navbar-dropdown--user">
          <button :data-testid="TEST_ID.NAVBAR.BUTTON_USER_MENU" class="ds-navbar__user-btn ds-body-big-bold" type="button" @click.stop="toggleUserMenu">
            <svg
              class="ds-navbar__user-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              aria-hidden="true"
            >
              <path d="M9 9C10.6575 9 12 7.6575 12 6C12 4.3425 10.6575 3 9 3C7.3425 3 6 4.3425 6 6C6 7.6575 7.3425 9 9 9ZM9 10.5C6.9975 10.5 3 11.505 3 13.5V14.25C3 14.6625 3.3375 15 3.75 15H14.25C14.6625 15 15 14.6625 15 14.25V13.5C15 11.505 11.0025 10.5 9 10.5Z" fill="currentColor"/>
            </svg>
            <span :data-testid="TEST_ID.NAVBAR.LABEL_USER_NAME">{{ username }}</span>
            <DsArrowUp v-if="isMenuOpen('user')" class="ds-navbar__arrow" />
            <DsArrowDown v-else class="ds-navbar__arrow" />
          </button>
          <div v-if="openMenu === 'user'" :data-testid="TEST_ID.NAVBAR.MENU_USER" class="ds-navbar-dropdown__menu ds-navbar-dropdown__menu--right" role="menu">
            <button v-if="canMenuPerfil" :data-testid="TEST_ID.NAVBAR.ITEM_PROFILE" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('perfil')">{{ $t('PERFIL_perfil') }}</button>
            <button v-if="sid == null" :data-testid="TEST_ID.NAVBAR.ITEM_CHANGE_PASSWORD" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('changePassword')">{{ $t('CHANGE_PASS_changePassword') }}</button>
            <button v-if="canMenu2FA" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('2fa')">{{ $t('TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication') }}</button>
            <button v-if="canMenuContacto" :data-testid="TEST_ID.NAVBAR.ITEM_CONTACT" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('contacto')">{{ $t('NAVBAR_contacto') }}</button>
            <button :data-testid="TEST_ID.NAVBAR.ITEM_LOGOUT" class="ds-navbar-dropdown__item ds-body-medium" type="button" @click="selectUserCommand('logout')">{{ $t('GENERAL_salir') }}</button>
          </div>
        </div>
      </div>

      <transition name="ds-navbar-mobile-overlay">
        <button
          v-if="isMobileView && mobileMenuOpen"
          class="ds-navbar__mobile-overlay"
          type="button"
          aria-label="Cerrar menu"
          @click="closeMenus"
        ></button>
      </transition>

      <transition name="ds-navbar-mobile-panel">
        <div v-if="isMobileView && mobileMenuOpen" class="ds-navbar__mobile-panel" :data-testid="TEST_ID.NAVBAR.PANEL_MOBILE">
          <nav class="ds-navbar__mobile-menu" aria-label="Mobile main">
            <button :data-testid="TEST_ID.NAVBAR.LINK_HOME_MOBILE" :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isHomeActive }]" type="button" @click="selectMenuCommand('/')">
              {{ $t('NAVBAR_inicio') }}
            </button>

            <div v-if="showPedidosMenu" class="ds-navbar-mobile-dropdown">
              <button :data-testid="TEST_ID.NAVBAR.BUTTON_PEDIDOS_TOGGLE_MOBILE" :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isPedidosActive }]" type="button" @click.stop="toggleMenu('mobile-pedidos')">
                {{ $t('NAVBAR_pedidos') }}
                <DsArrowUp v-if="isMenuOpen('mobile-pedidos')" class="ds-navbar__arrow" />
                <DsArrowDown v-else class="ds-navbar__arrow" />
              </button>
              <div v-if="openMenu === 'mobile-pedidos'" :data-testid="TEST_ID.NAVBAR.MENU_PEDIDOS_MOBILE" class="ds-navbar__mobile-submenu">
                <button v-if="canMenuPedido" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/pedidos') }]" type="button" @click="selectMenuCommand('/pedidos')">{{ $t('NAVBAR_pedidos') }}</button>
                <button v-if="canMenuPedidoDistribuidores" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/pedidosDistribuidores') }]" type="button" @click="selectMenuCommand('/pedidosDistribuidores')">{{ $t('NAVBAR_pedidosDistribuidores') }}</button>
                <button v-if="canMenuPedidoSubagentes" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/pedidosSubagentes') }]" type="button" @click="selectMenuCommand('/pedidosSubagentes')">{{ $t('NAVBAR_pedidosSubagentes') }}</button>
                <button v-if="canMenuFirmarRemito" :data-testid="TEST_ID.NAVBAR.ITEM_FIRMAR_REMITOS_MOBILE" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/firmarRemitos') }]" type="button" @click="selectMenuCommand('/firmarRemitos')">{{ $t('NAVBAR_firmarRemitos') }}</button>
              </div>
            </div>

            <button v-if="canMenuPresupuesto" :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isRouteActive('/presupuestos') }]" type="button" @click="selectMenuCommand('/presupuestos')">
              {{ $t('NAVBAR_presupuestos') }}
            </button>

            <div v-if="showProductosMenu" class="ds-navbar-mobile-dropdown">
              <button :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isProductosActive }]" type="button" @click.stop="toggleMenu('mobile-productos')">
                {{ $t('NAVBAR_productos') }}
                <DsArrowUp v-if="isMenuOpen('mobile-productos')" class="ds-navbar__arrow" />
                <DsArrowDown v-else class="ds-navbar__arrow" />
              </button>
              <div v-if="openMenu === 'mobile-productos'" class="ds-navbar__mobile-submenu">
                <button v-if="canMenuRegistroInstalacion" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/garantias') }]" type="button" @click="selectMenuCommand('/garantias')">{{ $t('NAVBAR_reg_instalacion') }}</button>
                <button v-if="canMenuGarantiaProximaVencer" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/garantias/expiracion') }]" type="button" @click="selectMenuCommand('/garantias/expiracion')">{{ $t('NAVBAR_expire_warranty') }}</button>
                <button v-if="canMenuSolicitudServicio" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/solicitudes') }]" type="button" @click="selectMenuCommand('/solicitudes')">{{ $t('NAVBAR_solicitudes') }}</button>
                <button v-if="canMenuAsociarRemito" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/remitos') }]" type="button" @click="selectMenuCommand('/remitos')">{{ $t('NAVBAR_remitos') }}</button>
              </div>
            </div>

            <div v-if="showCuentasMenu" class="ds-navbar-mobile-dropdown">
              <button :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isCuentasActive }]" type="button" @click.stop="toggleMenu('mobile-cuentas')">
                {{ $t('NAVBAR_cuentas') }}
                <DsArrowUp v-if="isMenuOpen('mobile-cuentas')" class="ds-navbar__arrow" />
                <DsArrowDown v-else class="ds-navbar__arrow" />
              </button>
              <div v-if="openMenu === 'mobile-cuentas'" class="ds-navbar__mobile-submenu">
                <button v-if="canMenuPendientes" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/pendientes') }]" type="button" @click="selectMenuCommand('/pendientes')">{{ $t('NAVBAR_pendientes') }}</button>
                <button v-if="canMenuResumenDeCuenta" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/resumenDeCuenta') }]" type="button" @click="selectMenuCommand('/resumenDeCuenta')">{{ $t('NAVBAR_resumenDeCuenta') }}</button>
              </div>
            </div>

            <div v-if="showComunidadMenu" class="ds-navbar-mobile-dropdown">
              <button :class="['ds-navbar__mobile-link', 'ds-body-big-bold', { 'is-active': isComunidadActive }]" type="button" @click.stop="toggleMenu('mobile-comunidad')">
                {{ $t('NAVBAR_comunidad') }}
                <DsArrowUp v-if="isMenuOpen('mobile-comunidad')" class="ds-navbar__arrow" />
                <DsArrowDown v-else class="ds-navbar__arrow" />
              </button>
              <div v-if="openMenu === 'mobile-comunidad'" class="ds-navbar__mobile-submenu">
                <button v-if="canMenuForo" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/foro') }]" type="button" @click="selectMenuCommand('/foro')">{{ $t('NAVBAR_foro') }}</button>
                <button v-if="canMenuGestionNoticias" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/gestionNoticias') || isRouteActive('/noticia') }]" type="button" @click="selectMenuCommand('/gestionNoticias')">{{ $t('NAVBAR_gestionNoticias') }}</button>
                <button v-if="canMenuGestionArchivo" :class="['ds-navbar__mobile-link', 'ds-body-medium', { 'is-active': isRouteActive('/archivos') }]" type="button" @click="selectMenuCommand('/archivos')">{{ $t('NAVBAR_archivos') }}</button>
              </div>
            </div>
          </nav>
        </div>
      </transition>
    </div>

    <CambioContrasenia
      :show="showCambioContrasenia"
      :onClose="() => { showCambioContrasenia = false }"
    />
  </header>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@/plugins/i18n'
import { targets } from '@/security/target'
import { tienePermiso } from '@/security/autorizador'
import CambioContrasenia from '../Login/cambioContrasenia'
import DsArrowDown from './DsArrowDown'
import DsArrowUp from './DsArrowUp'
import TEST_ID from '@/testIds.json'

const MOBILE_BREAKPOINT = 1200

export default {
  name: 'DsNavbar',
  components: { CambioContrasenia, DsArrowDown, DsArrowUp },
  props: {
    notificationCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      TEST_ID,
      openMenu: null,
      targets: targets,
      showCambioContrasenia: false,
      isMobileView: false,
      mobileMenuOpen: false
    }
  },
  computed: {
    ...mapState({
      sesion: state => state.sesion
    }),
    hasNotifications() {
      return this.notificationCount > 0
    },
    username() {
      return this.sesion.resultadoAutenticacion ? this.sesion.resultadoAutenticacion.Usuario : 'Usuario'
    },
    sid() {
      return this.sesion.resultadoAutenticacion ? this.sesion.resultadoAutenticacion.SID : null
    },
    currentLocale() {
      return i18n.locale
    },
    canMenuPedido() {
      return this.tienePermiso(this.targets.Menu_Pedido)
    },
    canMenuPedidoSubagentes() {
      return this.tienePermiso(this.targets.Menu_PedidoSubagentes)
    },
    canMenuPedidoDistribuidores() {
      return this.tienePermiso(this.targets.Menu_PedidoADistribuidores)
    },
    canMenuPresupuesto() {
      return this.tienePermiso(this.targets.Menu_Presupuesto)
    },
    canMenuFirmarRemito() {
      return this.tienePermiso(this.targets.Menu_FirmarRemito)
    },
    canMenuRegistroInstalacion() {
      return this.tienePermiso(this.targets.Menu_RegistroInstalacion)
    },
    canMenuGarantiaProximaVencer() {
      return this.tienePermiso(this.targets.Menu_GarantiaProximaVencer)
    },
    canMenuSolicitudServicio() {
      return this.tienePermiso(this.targets.Menu_SolicitudServicio)
    },
    canMenuAsociarRemito() {
      return this.tienePermiso(this.targets.Menu_AsociarRemito)
    },
    canMenuPendientes() {
      return this.tienePermiso(this.targets.Menu_Pendientes) || this.tienePermiso(this.targets.Menu_Clientes)
    },
    canMenuResumenDeCuenta() {
      return this.tienePermiso(this.targets.Menu_ResumenDeCuenta) || this.tienePermiso(this.targets.Menu_Clientes)
    },
    canMenuGestionNoticias() {
      return this.tienePermiso(this.targets.Menu_Gestion_Noticia)
    },
    canMenuForo() {
      return this.tienePermiso(this.targets.Menu_Foro)
    },
    canMenuGestionArchivo() {
      return this.tienePermiso(this.targets.Menu_Gestion_Archivo)
    },
    canMenuContacto() {
      return this.tienePermiso(this.targets.Menu_Contacto)
    },
    canMenuPerfil() {
      return this.tienePermiso(this.targets.Menu_Perfil)
    },
    canMenu2FA() {
      return this.tienePermiso(this.targets.Menu_2FA)
    },
    showPedidosMenu() {
      return this.canMenuPedido || this.canMenuPedidoDistribuidores || this.canMenuPedidoSubagentes || this.canMenuFirmarRemito
    },
    showProductosMenu() {
      return this.canMenuRegistroInstalacion || this.canMenuGarantiaProximaVencer || this.canMenuSolicitudServicio || this.canMenuAsociarRemito
    },
    showCuentasMenu() {
      return this.canMenuPendientes || this.canMenuResumenDeCuenta
    },
    showComunidadMenu() {
      return this.canMenuForo || this.canMenuGestionNoticias || this.canMenuGestionArchivo
    },
    isHomeActive() {
      return this.$route.path === '/'
    },
    isPedidosActive() {
      return this.isAnyRouteActive(['/pedidos', '/pedidosDistribuidores', '/pedidosSubagentes', '/firmarRemitos'])
    },
    isPresupuestosActive() {
      return this.isRouteActive('/presupuestos')
    },
    isProductosActive() {
      return this.isAnyRouteActive(['/garantias', '/solicitudes', '/remitos'])
    },
    isCuentasActive() {
      return this.isAnyRouteActive(['/pendientes', '/resumenDeCuenta'])
    },
    isComunidadActive() {
      return this.isAnyRouteActive(['/foro', '/gestionNoticias', '/archivos', '/noticia'])
    }
  },
  watch: {
    '$route.path'() {
      this.mobileMenuOpen = false
    },
    mobileMenuOpen(isOpen) {
      this.syncBodyScrollLock(isOpen && this.isMobileView)
    }
  },
  methods: {
    tienePermiso: tienePermiso,
    onResize() {
      this.isMobileView = window.innerWidth <= MOBILE_BREAKPOINT
      if (!this.isMobileView) {
        this.mobileMenuOpen = false
      }

      this.syncBodyScrollLock(this.mobileMenuOpen && this.isMobileView)
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      this.openMenu = null
    },
    isMenuOpen(menuName) {
      return this.openMenu === menuName
    },
    toggleMenu(menuName) {
      this.openMenu = this.openMenu === menuName ? null : menuName
    },
    toggleUserMenu() {
      const nextMenu = this.openMenu === 'user' ? null : 'user'

      if (this.isMobileView) {
        this.mobileMenuOpen = false
      }

      this.openMenu = nextMenu
    },
    closeMenus() {
      this.openMenu = null
      this.mobileMenuOpen = false
    },
    selectMenuCommand(routePath) {
      this.onMenuCommand(routePath)
      this.closeMenus()
    },
    selectUserCommand(command) {
      this.onUserCommand(command)
      this.closeMenus()
    },
    onClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeMenus()
      }
    },
    syncBodyScrollLock(shouldLock) {
      document.body.style.overflow = shouldLock ? 'hidden' : ''
    },
    onMenuCommand(routePath) {
      this.$router.push(routePath)
    },
    isRouteActive(routePath) {
      const currentPath = this.$route.path || ''
      if (routePath === '/') {
        return currentPath === '/'
      }

      return currentPath === routePath || currentPath.startsWith(`${routePath}/`)
    },
    isAnyRouteActive(routePaths) {
      return routePaths.some(routePath => this.isRouteActive(routePath))
    },
    toggleLocale() {
      const nextLocale = this.currentLocale === 'es' ? 'en' : 'es'
      this.setLocale(nextLocale)
    },
    setLocale(locale) {
      i18n.locale = locale
    },
    onUserCommand(command) {
      if (command === 'perfil') {
        this.$router.push({ name: 'Perfil' })
        return
      }

      if (command === '2fa') {
        this.$router.push({ name: 'TwoFactorAuthentication' })
        return
      }

      if (command === 'changePassword') {
        this.showCambioContrasenia = true
        return
      }

      if (command === 'contacto') {
        this.$router.push({ name: 'Contacto' })
        return
      }

      if (command === 'logout') {
        this.$store.dispatch('sesion/cerrarSesion').then(() => this.$router.push({ name: 'Login' }))
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
    document.addEventListener('click', this.onClickOutside)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('click', this.onClickOutside)
    this.syncBodyScrollLock(false)
  }
}
</script>

<style scoped>
.ds-navbar {
  width: 100%;
  align-self: stretch;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
}

.ds-navbar__inner {
  width: 100%;
  display: flex;
  padding: 17px 60px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  background: var(--ds-color-surface);
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.05);
  border-radius: 0;
}

.ds-navbar__left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.ds-navbar__logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 168px;
  height: 46px;
  border-radius: 6px;
  background-color: var(--ds-color-neutral-0);
}

.ds-navbar__logo {
  width: 100%;
  height: 80%;
  display: block;
  aspect-ratio: 84 / 23;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
}

.ds-navbar__menu {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ds-navbar__mobile-top,
.ds-navbar__mobile-panel {
  display: none;
}

.ds-navbar-mobile-panel-enter-active,
.ds-navbar-mobile-panel-leave-active {
  transition: transform 0.28s ease, opacity 0.28s ease;
}

.ds-navbar-mobile-overlay-enter-active,
.ds-navbar-mobile-overlay-leave-active {
  transition: opacity 0.28s ease;
}

.ds-navbar-mobile-overlay-enter,
.ds-navbar-mobile-overlay-leave-to {
  opacity: 0;
}

.ds-navbar-mobile-panel-enter,
.ds-navbar-mobile-panel-leave-to {
  opacity: 0;
  transform: translateX(-24px);
}

.ds-navbar__mobile-overlay {
  position: fixed;
  top: 71px;
  left: 0;
  right: 0;
  bottom: 0;
  border: 0;
  padding: 0;
  margin: 0;
  background: rgba(24, 24, 27, 0.38);
  cursor: pointer;
  z-index: 998;
}

.ds-navbar__mobile-top-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ds-navbar__hamburger {
  border: 0;
  background: transparent;
  color: var(--ds-color-neutral-700);
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 22px;
}

.ds-navbar__mobile-menu {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ds-navbar-mobile-dropdown {
  display: flex;
  flex-direction: column;
}

.ds-navbar__mobile-submenu {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
  margin-left: 12px;
  padding-left: 8px;
  border-left: 1px solid var(--ds-color-neutral-200);
}

.ds-navbar__mobile-link {
  width: 100%;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  color: var(--ds-color-neutral-500);
  text-align: left;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
}

.ds-navbar__mobile-link:hover {
  color: var(--ds-color-neutral-600);
  background: transparent;
}

.ds-navbar__mobile-link.is-active {
  color: var(--ds-color-neutral-950);
  background: transparent;
}

.ds-navbar__mobile-submenu .ds-navbar__mobile-link {
  color: var(--ds-color-neutral-700);
}

.ds-navbar__mobile-submenu .ds-navbar__mobile-link:hover {
  color: var(--ds-color-neutral-900);
  background: var(--ds-color-neutral-100);
}

.ds-navbar__mobile-submenu .ds-navbar__mobile-link.is-active {
  color: var(--ds-color-neutral-950);
  background: var(--ds-color-neutral-100);
}

.ds-navbar-dropdown {
  position: relative;
}

.ds-navbar-dropdown__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 210px;
  background: var(--ds-color-surface);
  border: 1px solid var(--ds-color-neutral-200);
  border-radius: 10px;
  box-shadow: 0 12px 24px rgba(24, 24, 27, 0.12);
  padding: 6px;
  z-index: 40;
}

.ds-navbar-dropdown__menu--right {
  left: auto;
  right: 0;
}

.ds-navbar-dropdown__item {
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--ds-color-neutral-700);
  text-align: left;
  padding: 9px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.ds-navbar-dropdown__item:hover {
  color: var(--ds-color-neutral-900);
  background: var(--ds-color-neutral-100);
}

.ds-navbar-dropdown__item.is-active {
  color: var(--ds-color-neutral-950);
  background: var(--ds-color-neutral-100);
}

.ds-navbar-dropdown__item:disabled {
  color: var(--ds-color-neutral-400);
  cursor: not-allowed;
}

.ds-navbar__link {
  display: inline-flex;
  align-items: center;
  border: 0;
  background: transparent;
  color: var(--ds-color-neutral-500);
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.ds-navbar__link:hover {
  color: var(--ds-color-neutral-600);
  background: transparent;
}

.ds-navbar__link.is-active {
  color: var(--ds-color-neutral-950);
  background: transparent;
}

.ds-navbar__link:focus,
.ds-navbar__link:focus-visible,
.ds-navbar__link:active {
  outline: none;
  box-shadow: none;
  background: transparent;
}

.ds-navbar__right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.ds-navbar__icon-btn {
  position: relative;
  border: 0;
  background: transparent;
  width: 24px;
  height: 24px;
  aspect-ratio: 1 / 1;
  padding: 0;
  border-radius: 0;
  cursor: pointer;
  color: var(--ds-color-neutral-600);
}

.ds-navbar__icon-btn:hover {
  opacity: 0.85;
}

.ds-navbar__bell-icon {
  width: 24px;
  height: 24px;
  aspect-ratio: 1 / 1;
  display: block;
  color: var(--ds-color-neutral-600);
}

.ds-navbar__notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ds-navbar__notification-badge > svg {
  width: 14px;
  height: 14px;
  display: block;
}

.ds-navbar__notification-count {
  position: absolute;
  width: 7px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  color: var(--ds-color-neutral-0);
}

.ds-navbar__locale {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 0;
  border: 1px solid var(--ds-color-neutral-200);
  border-radius: 21px;
}

.ds-navbar__locale-btn {
  display: flex;
  padding: 4px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  background: transparent;
  color: var(--ds-color-neutral-600);
  border-radius: 16px;
  cursor: pointer;
}

.ds-navbar__locale-btn.is-active {
  background: var(--ds-color-neutral-600);
  color: var(--ds-color-neutral-0);
}

.ds-navbar__user-btn {
  border: 0;
  background: transparent;
  padding: 8px 10px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: var(--ds-color-neutral-600);
}

.ds-navbar__user-btn--icon {
  padding: 8px;
  gap: 2px;
}

.ds-navbar__user-btn:hover {
  background: transparent;
}

.ds-navbar__user-btn:focus,
.ds-navbar__user-btn:focus-visible,
.ds-navbar__user-btn:active {
  outline: none;
  box-shadow: none;
  background: transparent;
}

.ds-navbar__user ::v-deep(.el-dropdown-selfdefine:focus),
.ds-navbar__user ::v-deep(.el-dropdown-selfdefine:focus-visible),
.ds-navbar__user ::v-deep(.el-dropdown-selfdefine:hover),
.ds-navbar__user ::v-deep(.el-dropdown-selfdefine:active) {
  outline: none;
  box-shadow: none;
  background: transparent;
}

.ds-navbar__user-icon {
  width: 18px;
  height: 18px;
  color: var(--ds-color-neutral-600);
  display: block;
}

.ds-navbar__arrow {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  color: currentColor;
}

.ds-navbar__user-btn .ds-navbar__arrow {
  margin-left: 0;
}

@media (max-width: 1200px) {
  .ds-navbar__menu {
    gap: 6px;
  }

  .ds-navbar__right {
    gap: 14px;
  }
}

@media (max-width: 1200px) {
  .ds-navbar__inner {
    padding: 12px 14px;
    flex-direction: column;
    align-items: stretch;
  }

  .ds-navbar__mobile-top {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .ds-navbar__mobile-panel {
    display: block;
    position: fixed;
    top: 71px;
    left: 0;
    bottom: 0;
    width: 40%;
    min-width: 350px;
    margin-top: 0;
    padding: 16px 14px 24px;
    overflow: hidden;
    box-sizing: border-box;
    border-top: 1px solid #DFDFDF;
    box-shadow: 12px 0 32px rgba(0, 0, 0, 0.08);
    background: #FFF;
    z-index: 999;
  }

  .ds-navbar__mobile-top-actions {
    margin-left: auto;
  }

  .ds-navbar__mobile-top-actions .ds-navbar__locale {
    padding: 2px;
  }

  .ds-navbar__mobile-top-actions .ds-navbar__locale-btn {
    padding: 2px 8px;
  }
}
</style>
